import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteAgencyGroup } from '../../../../actions';

class AgencyGroupDeleteButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
    };
  }

  onClickDelete = () => {
    const { dispatchDeleteAgencyGroup, agencyGroupId } = this.props;

    dispatchDeleteAgencyGroup({ agencyGroupId });
  };

  onClickShowModal = () => this.setState({ showModal: true });

  onClickCancel = () => this.setState({ showModal: false });

  render() {
    const { showModal } = this.state;

    const warningModal = (
      <ConfirmationModal
        show={showModal}
        onClickConfirm={this.onClickDelete}
        onClickCancel={this.onClickCancel}
      />
    );

    const deleteButton = (
      <Button color="danger" onClick={this.onClickShowModal}>
        Eliminar
      </Button>
    );

    return (
      <Fragment>
        {deleteButton}
        {warningModal}
      </Fragment>
    );
  }
}

AgencyGroupDeleteButton.propTypes = {
  agencyGroupId: PropTypes.number.isRequired,
  dispatchDeleteAgencyGroup: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchDeleteAgencyGroup: deleteAgencyGroup,
};

export default connect(null, mapDispatchToProps)(AgencyGroupDeleteButton);
